module.exports = __webpack_public_path__ + "static/media/my.e9d32a95.svg";